import React from 'react';
export function Card({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`bg-white rounded-lg border border-slate-200 shadow-sm ${className}`} data-id="element-184" data-mp="3dn46u2hkm2j">
      {children}
    </div>;
}
export function CardHeader({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`p-6 pb-4 ${className}`} data-id="element-185" data-mp="h4igkgc71lav">{children}</div>;
}
export function CardTitle({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h3 className="text-lg font-semibold leading-none tracking-tight text-slate-900" data-id="element-186" data-mp="r2g2uyaht80u">
      {children}
    </h3>;
}
export function CardContent({
  children,
  className = ''
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={`p-6 pt-0 ${className}`} data-id="element-187" data-mp="2suuj7sxe24f5">{children}</div>;
}